import { render, staticRenderFns } from "./errorpage.vue?vue&type=template&id=2dfa9f3f&scoped=true&"
import script from "./errorpage.vue?vue&type=script&lang=js&"
export * from "./errorpage.vue?vue&type=script&lang=js&"
import style0 from "./errorpage.vue?vue&type=style&index=0&id=2dfa9f3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa9f3f",
  null
  
)

export default component.exports